import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-page-style-three',
  templateUrl: './services-page-style-three.component.html',
  styleUrls: ['./services-page-style-three.component.scss']
})
export class ServicesPageStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
